import { useQuery } from "@tanstack/react-query";

import { platformGraph } from "@/api/platform-graph";
import { unwrapEnvelope, type EnvelopedFetchResult } from "@/api/errors";
import { useSessionScope } from "@/auth/use-session-scope";

// 1:1 uçları performance.read hücresinin ÜSTÜNE perm_perf_one_on_one_read ister;
// 360 ve 1:1 tabanı ikisi de performance.read verdiği için hücre tek başına
// ayırt etmez. Bu ayrıntılı iznin matris hücresi yok, effective-permissions onu
// göstermez. /v1/permissions/check aynı checkTargetAccess'i çağıranın kendi
// çalışan satırı üzerinde koşar; servis de kendi satırına karşı ölçer.
export const PERM_ONE_ON_ONE_READ = "perm_perf_one_on_one_read";

type PermissionCheckPost = (
  path: "/v1/permissions/check",
  init: { body: { permission: string; target: { employee_id: string } } },
) => Promise<EnvelopedFetchResult<{ granted: boolean; reason: string }>>;

/** Sunucunun 1:1 okuma kararını çağıranın kendi satırı için sorar; kimlik yokken sormaz. */
export function useOneOnOneAccess(employeeId: string | null, { enabled = true }: { enabled?: boolean } = {}) {
  const scope = useSessionScope();
  return useQuery({
    queryKey: ["one-on-ones", ...scope, "access", employeeId],
    queryFn: async () => {
      const post = platformGraph.POST as unknown as PermissionCheckPost;
      const data = await unwrapEnvelope(post("/v1/permissions/check", { body: { permission: PERM_ONE_ON_ONE_READ, target: { employee_id: employeeId! } } }));
      return { granted: data.granted };
    },
    enabled: enabled && employeeId !== null,
    staleTime: 60_000,
  });
}
